module.exports = "././img/roboto-v16-latin-regular.svg";


//////////////////
// WEBPACK FOOTER
// ../fonts/roboto-v16-latin-regular.svg
// module id = 829
// module chunks = 0